import { render } from "./SettingsPanelSegmentations.vue?vue&type=template&id=b5e75688"
import script from "./SettingsPanelSegmentations.vue?vue&type=script&lang=ts"
export * from "./SettingsPanelSegmentations.vue?vue&type=script&lang=ts"
script.render = render

export default script